<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.message.elements.attachments.types.order.action.title')"
    :info="customer.displayName"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.attach'), type: 'confirm', callback: handleConfirm, disabled: !valid },
    ]"
    :loading="loading"
    :portal="portal"
  >
    <div class="relative">
      <order-select
        v-model="order"
        :customer="customer"
      />
    </div>
  </o-dialog>
</template>

<script setup lang="ts">
import OrderSelect from '@/components/order/elements/Select.vue'

import { CustomerMessageAttachment, CustomerMessageAttachmentType } from '~/_api/models/customerMessage'

interface Props {
  portal?: string
  loading?: boolean
  customer: Record<string, any>
}

withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<{
  (e: 'confirm', attachments: any[]): void
}>()

const dialog = ref<any>()
const order = ref<any>(null)

const valid = computed(() => !!order.value)

const open = () => {
  order.value = null
  dialog.value.open()
}

const handleConfirm = async () => {
  if (!order.value) {
    return false
  }

  const attachment = new CustomerMessageAttachment({
    type: CustomerMessageAttachmentType.order,
    id: order.value.idOrder,
    data: order.value,
  })

  emit('confirm', [attachment])

  return true
}

defineExpose({ open })
</script>
